<template>
    <div>
        <b-container fluid>
            <b-row>
                <TopBar />
            </b-row>
            <b-row>
                <Imagery />
            </b-row>
            <b-row>
                <FindBestBusinessInTown />
            </b-row>
            <b-row>
                <Localized />
            </b-row>
            <b-row>
                <RecentActivities />
            </b-row>
            <b-row>
                <BrowseBusinessesByCategory />
            </b-row>
            <b-row>
                <Miniapps />
            </b-row>
            <b-row>
                <MobileApps />
            </b-row>
            <b-row>
                <Footer />
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.imagery {
    background-color: fuchsia;
}
</style>

<script>
import Imagery from '../components/home/Imagery'
import TopBar from '../components/home/TopBar'
import FindBestBusinessInTown from '../components/home/FindBestBusinessInTown'
import Localized from '../components/home/Localized'
import RecentActivities from '../components/home/RecentActivities'
import BrowseBusinessesByCategory from '../components/home/businesscategory/BrowseBusinessesByCategory'
import Miniapps from '../components/home/miniapp/Miniapps'
import MobileApps from '../components/home/mobileapp/MobileApps'
import Footer from '../components/footer/Footer'

export default {

    components: {
        Imagery,
        TopBar,
        FindBestBusinessInTown,
        Localized,
        RecentActivities,
        BrowseBusinessesByCategory,
        Miniapps,
        MobileApps,
        Footer
    },
    data() {
        return {

        }
    },
    
}
</script>